import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { setDisplayErrorSnackBar } from "../../../../../../../../../../../features/userSlice";
import { bizDevelopmentDashboardMobileService } from "../../../../../../../../../../../services/mobileAPI/biz-dev-dashboard.endpoints";

export const useOverviewConversionsMobileOverride = ({
  params,
  setDataAction,
  setLoadingAction,
}: any) => {
  const dispatch = useDispatch();
  const fetchOverride = useCallback(
    async (overrideParams: any) => {
      try {
        if (setLoadingAction) {
          dispatch(setLoadingAction(true));
        }
        const response =
          await bizDevelopmentDashboardMobileService.getOverviewConversionsMobileData(
            overrideParams || params,
          );
        if (!response?.status || response.status !== 200) {
          throw new Error("API failed");
        }
        dispatch(setDataAction(response.data?.data || []));
      } catch (e: any) {
        dispatch(
          setDisplayErrorSnackBar({
            message: e?.parsedText || "Failed to fetch override data",
            type: "error",
          }),
        );
      } finally {
        if (setLoadingAction) {
          dispatch(setLoadingAction(false));
        }
      }
    },
    [params, setDataAction, setLoadingAction, dispatch],
  );
  return { fetchOverride };
};
